import { Type } from "@angular/core";

import { PrimaryLookupService } from "../../impl/PrimaryLookupService";

import { AutoCompleteLabelValueLookupService } from "./AutoCompleteLabelValueLookupService";
import { IAutoCompleteLabelValuePromiseLookupService } from "../IAutoCompleteLabelValuePromiseLookupService";

import * as CubiqTS from "shared/cubiq-model-multi-asset";
import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

import { AutoCompleteLabelValue } from "../../../model/core/AutoCompleteLabelValue";
import { ServiceMessageBrokerFactory, PRIMITIVE } from "shared/provider-webworker";

import { CubiqWorker } from "../../../worker/CubiqWorker";

export abstract class AutoCompleteLabelValuePrimaryLookupService<
    K,
    V extends CubiqTS.ConcreteEncodable,
  >
  extends PrimaryLookupService<K, V>
  implements IAutoCompleteLabelValuePromiseLookupService
{
  constructor(
    protected base: AutoCompleteLabelValueLookupService<K, V>,
    factory: ServiceMessageBrokerFactory,
    lookupType: Type<V>,
    cubiqWorker: CubiqWorker,
    serviceChannel: string,
    modelUpdateEventType: Type<CubiqTS.ConcreteEncodable> = CubiqTS.ModelUpdateImpl,
  ) {
    super(base, factory, lookupType, cubiqWorker, serviceChannel, modelUpdateEventType);

    this.broker.registerMethod(
      "getLabelValueById",
      [PRIMITIVE],
      this.getLabelValueById.bind(this),
      PRIMITIVE,
    );
    this.broker.registerMethod(
      "getLabelValueByName",
      [PRIMITIVE],
      this.getLabelValueByName.bind(this),
      PRIMITIVE,
    );
  }

  getLabelValueById(opts?: {
    prefix?: string;
    skip?: number;
    limit?: number;
  }): Promise<AutoCompleteLabelValue[]> {
    return new Promise<Array<AutoCompleteLabelValue>>((res, rej) => {
      res(this.base.getLabelValueById(opts));
    });
  }

  getLabelValueByName(opts?: {
    prefix?: string;
    skip?: number;
    limit?: number;
  }): Promise<AutoCompleteLabelValue[]> {
    return new Promise<Array<AutoCompleteLabelValue>>((res, rej) => {
      res(this.base.getLabelValueByName(opts));
    });
  }
}
